import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const Coffee1 = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="262" viewBox="875.2 422.65 189.05 262.32" width="189" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <g>
        <path
          className={strokeStyle}
          d="M1001.05 585.52v45.6a13.6 13.6 0 0 0 13.59 13.59h24.4c4.13 0 7.83-1.84 10.32-4.75-23.36-5.37-36.53-26.19-41.12-60.04h-1.57a5.6 5.6 0 0 0-5.61 5.61Z"
          fill={shades.secondary.medium}
          strokeWidth={strokeWidth}
        />
        <path
          className={strokeStyle}
          d="M1008.24 579.91c4.59 33.85 17.76 54.68 41.12 60.04a13.6 13.6 0 0 0 3.27-8.83v-45.6a5.6 5.6 0 0 0-5.61-5.61z"
          fill={shades.white}
          strokeWidth={strokeWidth}
        />
        <path
          className={strokeStyle}
          d="M985.33 597.18v21.5a4.23 4.23 0 0 0 4.23 4.23h11.49v-9.98h-3.7a2.04 2.04 0 0 1-2.04-2.04v-5.91c0-1.12.91-2.04 2.04-2.04h3.7v-9.98h-11.49a4.23 4.23 0 0 0-4.23 4.23Z"
          fill={shades.primary.dark}
          strokeWidth={strokeWidth}
        />
      </g>
      <g>
        <path
          className={strokeStyle}
          d="M1035.77 471.07c-3.07 5.35-14.48 13.9-14.48 13.9s9.21 5.48 6.36 11.62-6.8 6.36-6.8 6.36 8.55 4.31 6.36 9.28-8.24 7.16-8.24 7.16 9.99.13 6.92 8.99-11.62 8.86-10.75 17.41c.55 5.39 10 13.33 10.3 13.58-.5-.21-23.9-10.11-28.58-28.02-4.74-18.1 10.39-24.68 17.19-21.61-.3-.29-21.19-20.93-17.19-34.65 4.03-13.82 17.19-6.8 17.19-6.8s-17.46-18.05-7.24-35.09c7.9-13.16 18.64-2.41 18.64-2.41s13.82-6.8 16.23 3.07-10.75 26.54-10.75 26.54 7.9 5.31 4.83 10.66Z"
          fill={shades.white}
          strokeWidth={strokeWidth}
        />
        <line className={strokeStyle} fill={shades.white} strokeWidth={strokeWidth} x1="1025.46" x2="1018.98" y1="430.81" y2="434.76" />
      </g>
    </svg>
  );
};
